export default {"src":"/_next/static/media/TGR.30199ace.svg","height":15,"width":159,"blurWidth":0,"blurHeight":0};